import * as WFC from './WFConstants'
import WFHelper from './WFHelper'

const uuidv4 = require('uuid/v4')

/**
 * Created by Xuz on 2020/01/08.
 * xuz@live.cn
 *
 * 节点对象的JS封装类
 * 起点、普通节点，结点
 */
class WFNode {
  constructor (workflow, nodeType) {
    this.workflow = workflow
    this.sType = nodeType || WFC.NODE_TYPE_COMMON_NODE
    this.dSvg = null
    this.dContainer = null
    this.iOffsetX = null
    this.iOffsetY = null
    this.dGtext = null
    this.dText = null
    this.dImg = null
    this.dGImg = null
    this.iImgWidth = 30
    this.iImgHeight = 33

    this.iLastPX = null
    this.iLastPY = null

    this.sAttrName = null
    this.sSendMode = null
    this.sSpecialType = ''
    this.sFlowType = null

    this.repeater = null
    this.bKilled = false
    this.bSrc = false

    this.sUuid = uuidv4()

    this.aPos = []
    this.aUser = []
    this.aRole = []
    this.aDept = []
    this.aYueUser = []
  }

  getType () {
    return this.sType
  }

  getName () {
    return this.sAttrName
  }

  setName (attr) {
    this.sAttrName = attr
    this.dText.tspan(this.sAttrName)
  }

  uuid () {
    return this.sUuid
  }

  getSvg () {
    return this.dSvg
  }

  isSrc () {
    return this.bSrc
  }

  /**
   * 获得节点上的循环器JS对象
   */
  getRepeater () {
    return this.repeater
  }

  /**
   * 设置节点上的循环器
   */
  setRepeater (repeater) {
    this.repeater = repeater
    if (repeater != null) {
      this.dSvg.attr('wf-repeater', this.repeater)
    } else {
      this.dSvg.attr('wf-repeater', null)
    }
  }

  create (event) {
    const oSvgJs = this.workflow.getSvgJs()
    const pos = WFHelper.getPos(event, this.workflow.getCTM())
    const ctx = this.workflow.parent.$_c

    this.dSvg = oSvgJs.group()
    this.serial()

    this.dContainer = oSvgJs.rect()

    let trans = 'translate(' + pos.x + ', ' + pos.y + ')'
    this.dSvg.attr('transform', trans)
    this.dContainer.attr('width', this.iImgWidth)
    this.dContainer.attr('height', this.iImgHeight + 20)
    this.dContainer.attr('fill', 'white')
    this.dContainer.attr('stroke', 'black')
    this.dContainer.attr('stroke-width', '0')
    this.dContainer.attr('style', 'opacity:0')
    this.dContainer.attr('style', 'background-color:transparent')

    this.dSvg.add(this.dContainer)

    this.dGImg = oSvgJs.group()
    this.dImg = null

    let uriImg = null
    switch (this.sType) {
      case WFC.NODE_TYPE_COMMON_NODE:
        uriImg = ctx + 'app/workflow/img/design/kuser.png'
        break
      case WFC.NODE_TYPE_START_NODE:
        uriImg = ctx + 'app/workflow/img/design/start.png'
        break
      case WFC.NODE_TYPE_END_NODE:
        uriImg = ctx + 'app/workflow/img/design/end.png'
        break
      case WFC.NODE_TYPE_TRANS_NODE:
        uriImg = ctx + 'app/workflow/img/design/tran.png'
        break
    }

    this.dImg = oSvgJs.image(uriImg).size(this.iImgHeight, this.iImgWidth)
    // this.dImg.attr('width', this.iImgHeight)
    // this.dImg.attr('height', this.iImgWidth)

    trans = 'translate(' + 2 + ', ' + 2 + ')'
    this.dGImg.attr('transform', trans)
    this.dGImg.add(this.dImg)
    this.dSvg.add(this.dGImg)

    switch (this.sType) {
      case WFC.NODE_TYPE_COMMON_NODE:
        this.sAttrName = WFHelper.getNextTargetName()
        break
      case WFC.NODE_TYPE_START_NODE:
        this.sAttrName = WFHelper.getStartNodeName()
        break
      case WFC.NODE_TYPE_END_NODE:
        this.sAttrName = WFHelper.getNextEndNodeName()
        break
      case WFC.NODE_TYPE_TRANS_NODE:
        this.sAttrName = WFHelper.getNextTransName()
        break
    }

    this.dGtext = oSvgJs.group()
    this.dText = oSvgJs.text('')
    this.dText.tspan(this.sAttrName)
    trans = 'translate(0,' + (this.iImgHeight + 13) + ')'
    this.dGtext.attr('transform', trans)
    this.dGtext.add(this.dText)
    this.dSvg.add(this.dGtext)
    const that = this
    this.dSvg.mousedown(event => that.workflow.onMouseDown(event))
    oSvgJs.add(this.dSvg)

    this.fixLayout()

    this.workflow.registerElement(this)
  }

  fixLayout () {
    const textRect = WFHelper.getRect(this.dText)
    const imgRect = WFHelper.getRect(this.dImg)
    let maxRect = null

    if (textRect.width > imgRect.width) {
      maxRect = textRect
    } else {
      maxRect = imgRect
    }

    this.dContainer.attr('width', maxRect.width + 4)
    if (maxRect === textRect) {
      const posx = (textRect.width - imgRect.width) / 2
      this.dImg.attr('x', posx)
      this.dText.attr('x', 0)
    } else {
      this.dImg.attr('x', 0)
      const posx = (imgRect.width - textRect.width) / 2
      this.dText.attr('x', posx)
    }

    // 如果有循环器，还要修正循环器的坐标
    if (this.repeater != null) {
      this.workflow.getElement(this.repeater).fixLayout()
    }

    this.workflow.moveLinkers(this.sUuid)
  }

  serial () {
    this.dSvg.attr('uuid', this.sUuid)
    this.dSvg.attr('wf-class', 'WFNode')
    this.dSvg.attr('wf-node-type', this.sType)
  }

  unSerial (svg) {
    this.bSrc = true
    this.dSvg = svg
    let children = this.dSvg.children()
    this.sUuid = this.dSvg.attr('uuid')
    this.sType = this.dSvg.attr('wf-node-type')
    this.dContainer = children[0]
    this.dContainer.attr('style', 'background-color:transparent')
    this.dImg = children[1].children()[0]
    this.dText = children[2].children()[0]
    this.sAttrName = this.dText.text()

    let repeaterId = this.dSvg.attr('wf-repeater')
    if (repeaterId != null && repeaterId !== '') {
      this.repeater = repeaterId
    }

    this.workflow.registerElement(this)

    if (this.sType === WFC.NODE_TYPE_START_NODE) {
      this.workflow.setStartNode(this)
    }
  }

  onSelect (event) {
    this.dContainer.attr('stroke-width', '1')
    this.dContainer.attr('style', 'opacity:0.8;')
    const that = this
    const oSvgJs = this.workflow.getSvgJs()
    oSvgJs.mousemove(event => that.workflow.onMouseMove(event))

    let pos = WFHelper.getPos(event, this.workflow.getCTM())
    let bound = this.dSvg.matrix()
    this.iOffsetX = pos.x - bound.e
    this.iOffsetY = pos.y - bound.f
  }

  onUnSelect (event) {
    this.dContainer.attr('stroke-width', '0')
    this.dContainer.attr('style', 'opacity:1;background-color:transparent')
    const oSvgJs = this.workflow.getSvgJs()
    oSvgJs.mousemove(null)
  }

  onMove (event) {
    if (this.workflow.isMouseDowning()) {
      let pos = WFHelper.getPos(event, this.workflow.getCTM())
      if (pos.x < WFC.iToolbarWidth || pos.x > WFC.iCanvasMaxWidth || pos.y < WFC.iCanvasMaxTop || pos.y > WFC.iCanvasMaxHeight) {
        return
      }
      if (this.iLastPX != null) {
        // this.bRegChanged = true
      }
      let x = pos.x - this.iOffsetX
      let y = pos.y - this.iOffsetY
      let trans = 'translate(' + x + ', ' + y + ')'
      this.dSvg.attr('transform', trans)
      // this.dSvg.move(x, y)
      this.workflow.moveLinkers(this.sUuid)

      if (this.repeater != null) {
        this.workflow.getElement(this.repeater).onMove(event, this)
      }

      this.iLastPX = pos.x
      this.iLastPY = pos.y
    }
  }

  onMouseDblClick (event) {
    let parent = this.workflow.getParent()
    switch (this.sType * 1) {
      case WFC.NODE_TYPE_COMMON_NODE:
        let bForce = false
        if (event.shiftKey) {
          if (!confirm('是否确认打开全编辑模式？')) {
            return
          }
          bForce = true
        }
        parent.onEditCommonNode(this)
        break
      case WFC.NODE_TYPE_START_NODE:
        parent.onEditStartNode(this)
        break
      case WFC.NODE_TYPE_END_NODE:
        parent.onEditEndNode(this)
        break
      case WFC.NODE_TYPE_TRANS_NODE:
        parent.onEditTransNode(this)
        break
    }
  }

  onUp ($evt) {

  }

  onLinkerOut (event) {
    this.dContainer.attr('style', 'stroke:black;stroke-width:0;opacity:1')
  }

  onLinkerOver (event) {
    let startNode = this.workflow.getStartNode()
    let lastEl = this.workflow.getLastElement()
    if (startNode != null) {
      if (startNode === lastEl) {
        // 如果连接的对象不是普通节点就不是合法的
        if (this.sType !== WFC.NODE_TYPE_COMMON_NODE) {
          this.workflow.setMessage('startnode.onlycan.link.common')
          this.setOutLine(false)
          return
        }
      }
    }
    // 如果路已经创建显示不同的风格
    if (!this.workflow.isRoadCreated(lastEl.uuid(), this.sUuid)) {
      // 如果路径指向起点也是不合法的
      if (this.sType !== WFC.NODE_TYPE_START_NODE) {
        this.setOutLine(true)
      } else {
        this.workflow.setMessage('startnode.notlink')
        this.setOutLine(false)
      }
    } else {
      this.workflow.setMessage('road.exist')
      this.setOutLine(false)
    }
  }

  /**
   * 设置连接时的状态
   */
  setOutLine (type) {
    if (type) {
      // 可连接状态
      this.dContainer.attr('style', 'stroke-dasharray:5.5;stroke:blue;stroke-width:1;opacity:0.8')
    } else {
      // 不可连接状态
      this.dContainer.attr('style', 'stroke-dasharray:5.5;stroke:red;stroke-width:1;opacity:0.8')
    }
  }

  /**
   * 移除实体，当实体移除时其循环器也需要被移除，其相关的连接器也需要被移除
   */
  remove () {
    if (this.bKilled) {
      return
    }
    this.dSvg.remove()

    if (this.repeater != null) {
      this.workflow.getElement(this.repeater).remove()
    }

    let linkers = this.workflow.getNodeRoads(this.sUuid)
    if (linkers != null) {
      for (let i = 0; i < linkers.length; i++) {
        if (linkers[i] != null) {
          linkers[i].remove()
        }
      }
    }

    this.workflow.unregisterElement(this)
    this.bKilled = true
  }

  pushWFAttributes (formData) {
    const wfXml = this.workflow.getWfXml()
    WFHelper.pushWFFormAttributes(formData, wfXml.getNode(this.sUuid))
  }

  /**
   * 获得工作流的属性
   */
  getWFAttributes (attrName) {
    if (attrName === 'POS') {
      return this.aPos;
    } else if (attrName === 'USER') {
      return __clone(this.aUser)
    } else if (attrName === 'DEPT') {
      return __clone(this.aDept)
    } else if (attrName === 'ROLE') {
      return this.aRole
    }
  }

  onToolbarChange (tId) {
  }

  getXmlNode (dXml) {
    let node = dXml.createElement('activity')
    node.setAttribute('name', this.sAttrName)
    node.setAttribute('uuid', this.sUuid)
    node.setAttribute('type', this.sType)
    return node
  }

  setWFAttributes (attrName, value) {
    const wfXml = this.workflow.getWfXml()
    if (attrName === 'FORM') {
      const oXml = wfXml.getXml()
      let nodes = WFHelper.createWFFormAttributesNode(value, oXml)
      let node = wfXml.getNode(this.sUuid)
      WFHelper.removeWFFormAttributes(node)
      for (let i = 0; i < nodes.length; i++) {
        node.appendChild(nodes[i])
      }
    }

    if (attrName === 'SPECIAL_TYPE') {
      this.sSpecialType = value
    }

    if (attrName === 'USER') {
      this.aUser = value
    }

    if (attrName === 'YUEUser') {
      this.aYueUser = value
    }

    if (attrName === 'DEPT') {
      this.aDept = value
    }

    if (attrName === 'POS') {
      this.aPos = value
    }

    if (attrName === 'ROLE') {
      this.aRole = value
    }

    if (attrName === 'SEND_MODE') {
      this.sSendMode = value
    }
    if (attrName === 'FLOW_TYPE') {
      this.sFlowType = value
    }
  }

  /**
   * 获得特殊属性
   */
  getSpecialType () {
    return this.sSpecialType
  }

  getFlowType () {
    return this.sFlowType
  }

  setIcon (path) {
    const ctx = this.workflow.parent.$_c
    const oSvgJs = this.workflow.getSvgJs()
    // this.dImg = oSvgJs.image(ctx + path)
    let newImg = oSvgJs.image(ctx + path).size(this.iImgHeight, this.iImgWidth)
    this.dImg.replace(newImg)
    this.dImg = newImg
  }

  /**
   * 更新节点的描述信息
   */
  updateXmlNode () {
    let oWFXml = this.workflow.getWfXml()
    let dNode = oWFXml.getNode(this.sUuid)
    dNode.setAttribute('name', this.sAttrName)

    let oXml = oWFXml.getXml()
    // 重新设置用户描述数据
    let removeNodes = dNode.getElementsByTagName('user')
    while (removeNodes[0]) {
      removeNodes[0].parentNode.removeChild(removeNodes[0])
    }
    let user = null
    for (let i in this.aUser) {
      user = this.aUser[i]
      if (user == null) {
        continue
      }
      let userNode = oXml.createElement('user')
      userNode.setAttribute('uuid', user.id)
      userNode.setAttribute('name', user.name)
      dNode.appendChild(userNode)
    }

    // 重新设置传阅用户描述数据
    removeNodes = dNode.getElementsByTagName('yuser')
    while (removeNodes[0]) {
      removeNodes[0].parentNode.removeChild(removeNodes[0])
    }
    let yuser = null
    for (let i in this.aYueUser) {
      yuser = this.aYueUser[i]
      if (yuser == null) {
        continue
      }
      let userNode = oXml.createElement('yuser')
      userNode.setAttribute('uuid', yuser.id)
      userNode.setAttribute('name', yuser.name)
      dNode.appendChild(userNode)
    }

    // 重新设置部门描述数据
    removeNodes = dNode.getElementsByTagName('dept')
    while (removeNodes[0]) {
      removeNodes[0].parentNode.removeChild(removeNodes[0])
    }
    let dept = null
    for (let i in this.aDept) {
      dept = this.aDept[i]
      if (dept == null) {
        continue
      }
      let deptNode = oXml.createElement('dept')
      deptNode.setAttribute('uuid', dept.id)
      deptNode.setAttribute('name', dept.name)
      dNode.appendChild(deptNode)
    }
    // 重新设置岗位描述数据
    removeNodes = dNode.getElementsByTagName('pos')
    while (removeNodes[0]) {
      removeNodes[0].parentNode.removeChild(removeNodes[0])
    }
    let pos = null
    for (let i in this.aPos) {
      pos = this.aPos[i]
      if (pos == null) {
        continue
      }
      let node = oXml.createElement('pos')
      node.setAttribute('uuid', pos.id)
      node.setAttribute('name', pos.name)
      dNode.appendChild(node)
    }
    // 重新设置角色描述数据
    removeNodes = dNode.getElementsByTagName('role')
    while (removeNodes[0]) {
      removeNodes[0].parentNode.removeChild(removeNodes[0])
    }
    let role = null
    for (let i in this.aRole) {
      role = this.aRole[i]
      if (role == null) {
        continue
      }
      let node = oXml.createElement('role')
      node.setAttribute('uuid', role.id)
      node.setAttribute('name', role.name)
      dNode.appendChild(node)
    }
  }

  debug () {
    let oWFXml = this.workflow.getWfXml()
    alert(oWFXml.getSrcXml())
  }
}

export default WFNode
